import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from "rehype-raw";

export const MarkdownWithTargetBlank = ({ children }: { children: string }) => {
    return (
        <Markdown rehypePlugins={[rehypeRaw]}
            components={{
                a: ({ node, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer" />
                ),
            }}
        >
            {children}
        </Markdown>
    );
};
